import { connect } from 'react-redux'
import MembershipPane from '../../../components/riders/riderdetails/membership/MembershipPane'
import * as actions from '../../../state/actions/riders'
import * as serviceActions from '../../../state/actions/services'
import * as membershipActions from '../../../state/actions/membership_request'
import { IMembershipObject, IStoreState } from '../../../types'
import { getMembershipsByIds } from '../../../state/reducers/membership_request/index'
import { getProviderProducts } from '../../../state/reducers/provider-products/index'
import { getRiderById } from '../../../state/reducers/riders/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const rider = getRiderById(state.riders, ownProps.riderId)
  return {
    rider,
    orgId: state.organizations.currentOrgId,
    riderId: ownProps.riderId,
    memberships: state.membership.items,
    services: state.service.items,
    providerProducts: getProviderProducts(state.providerProduct)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getMembershipList: (riderId: string, orgId: string) =>
      dispatch(membershipActions.getMembershipListByRiderIdAndOrgId(riderId, orgId)),

    getServiceList: (type: string, orgId: string) => {
      dispatch(serviceActions.fetchServiceList(type, orgId))
    },
    suspend: (membership: IMembershipObject) => {
      return dispatch(actions.ridersDetailsSuspendMembership(membership))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipPane)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/MembershipPane.ts